<div class="body">
    <div class="forgot-password-form">
        <div class="content">
            <h1>Reset Password</h1>
            <form (ngSubmit)="onSubmit()" [formGroup]="resetPasswordForm">
                <!-- <div class="wrap-input100 validate-input" data-validate="Access token is required" data-failed="Wrong Email o Password">
                    <input class="input100" [type]="showTemporary ? 'text' : 'password'" name="token" formControlName="token" placeholder="Password temporanea">
                    <span class="eye-icon" (click)="switchTemporary()">
                        <mat-icon class="material-icons-outlined" [ngClass]="{'open-eye': showTemporary, 'closed-eye': !showTemporary}"></mat-icon>
                    </span>
                    <span class="symbol-input100 icon">
                    <mat-icon>key</mat-icon>
                    </span>
                </div> -->
                <div class="wrap-input100 validate-input" data-validate="Password is required" data-failed="Wrong Email o Password">
                    <input class="input100" [type]="showPassword ? 'text' : 'password'" name="pass" formControlName="password" placeholder="Password" minlength="6" (input)="confirm = false; notMatched = false">
                    <span class="eye-icon" (click)="switchPassword()">
                        <mat-icon class="material-icons-outlined" [ngClass]="{'open-eye': showPassword, 'closed-eye': !showPassword}"></mat-icon>
                    </span>
                    <span class="symbol-input100 icon">
                    <mat-icon>lock</mat-icon>
                    </span>
                </div>

                <div class="wrap-input100 validate-input" data-validate="Password is required" data-failed="Wrong Email o Password">
                    <input class="input100" [type]="showConfirm ? 'text' : 'password'" name="pass" formControlName="confirmPassword" placeholder="Conferma Password" minlength="6" (input)="notMatched = false">
                    <span class="eye-icon" (click)="switchConfirm()">
                        <mat-icon class="material-icons-outlined" [ngClass]="{'open-eye': showConfirm, 'closed-eye': !showConfirm}"></mat-icon>
                    </span>
                    <span class="symbol-input100 icon">
                    <mat-icon>lock</mat-icon>
                    </span>
                </div>
                <div class="container-login100-form-btn">
                    <button type="submit" class="login100-form-btn">Resetta Password</button>
                </div>
            </form>
            <div class="toaster toaster" *ngIf="confirm">
                <p>Password modificata con successo! Ti stiamo portando al login...</p>
            </div>
            <div class="failed-toaster toaster" *ngIf="password && confirm == false && submitted && validateToken == false">
                <p>Token non valido</p>
            </div>
            <div class="failed-toaster toaster" *ngIf="password && notMatched">
                <p>Le password non corrispondono</p>
            </div>
            <div class="failed-toaster toaster" *ngIf="password && validatePassword == false && submitted">
                <p>La password deve avere minimo {{ minLength }} caratteri</p>
            </div>
            <div class="loading-toaster toaster" *ngIf="password && confirm == null && submitted">
                <p>Risposta dal server in corso</p>
            </div>
    </div>
</div>
